module.exports["cssLoader"] = function() { return require("css-loader"); };
module.exports["postcssLoader"] = function() { return require("postcss-loader"); };
module.exports["styleLoader"] = function() { return require("style-loader"); };